import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch } from "react-redux";

import profileApi from "../api/profile";
import { classNames } from "../helpers";
import i18n from "../i18n";
import { setLoading } from "../store";
import { createWorkExperienceHandling } from "../services/workExperiences";

import Alert from "./Alert.jsx";
import TalentDetails from "./TalentDetails.jsx";
import TalentHeader from "./TalentHeader.jsx";
import TalentShortView from "./TalentShortView.jsx";

export default function ProfileDetails() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(async () => {
    dispatch(setLoading(true));
    let result;
    try {
      result = await profileApi.me();
      setData(result);
    } catch (err) {
      setError(
        (err.response && err.response.error) ||
          err.message ||
          i18n.t("errors.profile_details_load_error")
      );
    }
    dispatch(setLoading(false));
  }, []);

  const { addOrUpdateExperience, deleteExperience } =
    createWorkExperienceHandling(data, setData);

  if (error) {
    return (
      <Alert class="mb-16 profile-details__error" error>
        {error}
      </Alert>
    );
  }
  if (!data) {
    return <div></div>;
  }

  return (
    <div class={classNames("profile-details")}>
      <TalentHeader userData={data} />

      <div class="row">
        <div class="col s12 m8 push-m1">
          <TalentShortView class="mb-48" user={data} />
          <TalentDetails
            user={data}
            isSelf={true}
            addOrUpdateExperience={addOrUpdateExperience}
            deleteExperience={deleteExperience}
          />
        </div>
      </div>
    </div>
  );
}
